import { render, staticRenderFns } from "./IndentList.vue?vue&type=template&id=83804d3a&scoped=true"
import script from "./IndentList.vue?vue&type=script&lang=js"
export * from "./IndentList.vue?vue&type=script&lang=js"
import style0 from "./IndentList.vue?vue&type=style&index=0&id=83804d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83804d3a",
  null
  
)

export default component.exports